import React, { Component } from 'react'

// Elements
import Icon from '../icon'

// Styles
import './sideMenuHeader.scss'

class SideMenuHeader extends Component {
  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return ' size-large'
      case 'm':
        return ' size-medium'
      case 's':
        return ' size-small'
    }
  }

  getStyle () {
    return 'element-sidemenu-header__label' + this.getSizeClass()
  }

  renderLabel () {
    return (
      <div className={this.getStyle()}>
        <Icon icon={this.props.icon} size='s' />
        {this.props.label}
      </div>
    )
  }

  render () {
    return (
      <div className='element-sidemenu-header'>
        {this.renderLabel()}
        {this.props.children}
      </div>
    )
  }
}

SideMenuHeader.defaultProps = {
  size: 'l',
  label: null
}

export default SideMenuHeader



// WEBPACK FOOTER //
// ./src/app/shared/elements/sideMenuHeader/index.js